import React, { forwardRef } from 'react';
import Login from '../Login';
import { Search } from '../Search';
import styled from 'styled-components';
import classNames from 'classnames';
import topSearchesDefault from './topSearches';
import { AutomationPlacement } from '../../utilities/automation';
import useLanguage from "../../utilities/useLanguage";
import { getSettingAsObject, SettingsEnum } from '../../utilities/settings';
import { getTranslation } from './translations';

const Concierge = forwardRef((props: any, ref: any) => {
    const { lang } = useLanguage();

    const topSearches = lang === 'es' ? getSettingAsObject(SettingsEnum.TOP_SEARCHES_ES) : getSettingAsObject(SettingsEnum.TOP_SEARCHES_EN);
    const dropdownPlaceholder = topSearches.placeholder ?  topSearches.placeholder : getTranslation(lang).seeTopSearches;
    const dropdownOptions = topSearches.options ?  topSearches.options :  topSearchesDefault[lang];

    return (
        <div data-id={props.cmsId} ref={ref} className={classNames('container', props.editorClassObj, props.className)}>
            <div className="row p-xs-2 align-items-center" style={{ flex: "1 1 0px" }}>
                <div className="col-5 col-lg-4 px-4 px-xl-5_5 py-5_5 d-lg-block d-none align-self-stretch login-container">
                    <Login />
                </div>
                <div className="col-lg-8 p-5 col-12 align-self-stretch d-flex align-items-center justify-content-center flex-column search-container">
                    <h2 className="mb-4 text-primary text-center text-serif">{getTranslation(lang).whatCanWeHelpYouWith}</h2>
                    <Search
                        inputClass='text-dark bg-white'
                        containerClass='rounded-lg bg-redRock'
                        placement={AutomationPlacement.HOME_PAGE}
                        inputPlaceholder={getTranslation(lang).startTypingHere} />
                </div>
            </div>
        </div>
    )
});

export default styled(Concierge)`
    position: relative;
    z-index: 1;

    .login-container {
        background-color: ${props => props.theme.gray250};
    }
    .search-container {
        background-color: ${props => props.theme.gray150};
    }
`